import { render } from "./topicRelease.vue?vue&type=template&id=64471fe2&scoped=true"
import script from "./topicRelease.vue?vue&type=script&lang=js"
export * from "./topicRelease.vue?vue&type=script&lang=js"

import "./topicRelease.vue?vue&type=style&index=0&id=64471fe2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64471fe2"]])

export default __exports__